import $ from 'jquery';

const importSwiper = () => import('swiper').then((module) => module.default);

//lightbox
if ($('a[data-lightbox]').length) {
    import('simplelightbox').then(() => {
        new SimpleLightbox('a[data-lightbox]', {
            captionPosition: 'outside'
        });
    });
}

//scrollto
$('[data-scroll]').click(function () {
    var $this = $(this),
        id = $this.data('scroll') || $this.attr('href').substr(1);

    $('#' + id)[0].scrollIntoView({
        behavior: 'smooth'
    });

    return false;
});

//rwd menu 
$('.rwd-icon.hamburger').click(function () {
    $('#rwd-menu').removeClass('search-open');
    $('#rwd-menu').addClass('open');
});

$('.rwd-icon.search-btn').click(function () {
    $('#rwd-menu').removeClass('open');
    $('#rwd-menu').addClass('search-open');
    $('#rwd-menu .search_txt').focus();
});

$('.rwd-icon.close, .rwd-menu-content').click(function () {
    $('#rwd-menu').removeClass('open search-open');
});

//radio labels
$('input[type=radio]').each(function () {
    var $input = $(this),
        $label = $('label[for=' + $input.attr('id') + ']');

    $input.addClass('radio');

    $label.on('checked', function () {
        $('input[name="' + $input.attr('name') + '"][type=radio]').each(function () {
            $('label.here[for="' + $(this).attr('id') + '"]').removeClass('here');
        });
        $(this).addClass('here');
    });

    $input.click(function () {
        $label.trigger('checked');
    });

    if ($input.is(':checked')) {
        $label.trigger('checked');
    }
});

//main swiper    
$('#main-slider').each(function () {
    $(this).addClass('shown');
    importSwiper()
        .then((Swiper) => {
            new Swiper('#main-slider .container', {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 3000
                },
                fadeEffect: {
                    crossFade: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            });
        });
})

//page swiper
$('.page-slider').each(function () {
    importSwiper()
        .then((Swiper) => {
            //page
            var pageSwiper = new Swiper(this, {
                slidesPerView: 1,
                loop: false,
                autoHeight: true,
                pagination: {
                    el: '.page-pagination',
                    clickable: true,
                    bulletClass: 'page-button',
                    bulletActiveClass: 'page-button-active',
                    renderBullet: function (index, className) {
                        var slide = $('.page-slider .swiper-slide.page')[index];

                        return '<span class="' + className + '">' + $(slide).data('name') + '</span>';
                    }
                }
            });

            $('.page-slider img').on('load', function () {
                pageSwiper.updateAutoHeight(200);
            });

            if ($('.page-slider img').length) {
                setTimeout(function () {
                    pageSwiper.updateAutoHeight(200);
                }, 1000);
            }
        });
})

//header
$('.header_panel .gallery').each(function () {
    importSwiper()
        .then((Swiper) => {
            //header
            new Swiper(this, {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 5000
                },
                speed: 2000,
                effect: 'fade',
                slideClass: 'header-slide',
                slideActiveClass: 'active',
                wrapperClass: 'header-wrapper',
                pagination: {
                    el: '.nav ul',
                    clickable: true,
                    bulletClass: 'bullet',
                    bulletActiveClass: 'active',
                    renderBullet: function (index, className) {
                        return '<li class="' + className + '"></li>';
                    }
                }
            });
        });
});

//product
$('.main_product').each(function () {
    importSwiper()
        .then((Swiper) => {
            //product images/dimensions
            new Swiper('#Images', {
                slidesPerView: 1,
                pagination: {
                    el: '.photo-pagination',
                    bulletClass: 'photo-bullet',
                    bulletActiveClass: 'here',
                    clickable: true,
                    renderBullet: function (index, className) {
                        var slide = $('#Images .swiper-slide')[index];

                        return '<span class="' + className + '">' + $(slide).data('name') + '</span>';
                    }
                }
            });

            const size = 7;
            //product variants
            let variantSwiper = new Swiper('.product_sizes .slider-active .slider', {
                slideClass: 'slide',
                wrapperClass: 'content',
                slidesPerView: size,
                loop: true,
                navigation: {
                    nextEl: '.slider_controls .next',
                    prevEl: '.slider_controls .prev'
                }
            });

            var index = 0;
            $('.product_sizes .slider-active .slider .slide').each(function () {
                if ($(this).hasClass('here') && !index) {
                    index = $(this).data('swiper-slide-index');
                }
            });

            if (index >= size) {
                variantSwiper.slideToLoop(index - size + 2, 0);
            }

            //product render/images
            new Swiper('.product-slider .swiper-container', {
                direction: 'horizontal',
                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                },

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                autoplay: {
                    delay: 5000,
                }
            });
        });
});

//SF
$('.street-furniture section.new .new-slider').each(function () {
    importSwiper()
        .then((Swiper) => {
            new Swiper(this, {
                slidesPerView: 3,
                centeredSlides: true,
                slideClass: 'product',
                wrapperClass: 'product-list',
                loop: true,
                navigation: {
                    nextEl: '.nav .right',
                    prevEl: '.nav .left',
                },
                autoplay: {
                    delay: 3000,
                },
            });
        });
});

//gallery
if ($('.swiper-gallery').length) {
    importSwiper()
        .then((Swiper) => {
            $('.swiper-gallery').each(function () {
                var $this = $(this);

                var options = {
                    slidesPerView: $this.data('slides'),
                    centeredSlides: true,
                    autoplay: {
                        delay: $this.data('auto'),
                    },
                    effect: $this.data('effect'),
                    loop: !!$this.data('loop'),
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    }
                };

                if ($this.data('breakpoints')) {
                    options.breakpoints = $this.data('breakpoints');
                }

                if ($this.data('navigation')) {
                    options.navigation = {
                        nextEl: '.navi-next-' + $this.attr('id'),
                        prevEl: '.navi-prev-' + $this.attr('id'),
                    };
                }
                ;

                new Swiper('#' + $this.attr('id') + ' .swiper-container', options);
            });
        });
}

var observeNewsletter = function () {
    $('.newsletter-ajax form').on('submit', function () {
        var $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            data: $form.serialize(),
            type: $form.attr('method'),
            success: function (data) {
                $('#newsletter-container').html(data);
                observeNewsletter();
            }
        });

        return false;
    });

    $('.newsletter-ajax .newsletter-link').on('click', function () {
        var $link = $(this);

        $('#newsletter-container').load($link.attr('href'), function () {
            setTimeout(function () {
                observeNewsletter();
            }, 200);
        });

        return false;
    });

    importSwiper()
        .then((Swiper) => {
            new Swiper('.newsletter-banners .swiper-container', {
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        });
};

var loadNewsletter = function () {
    $('#newsletter-container').load($('#newsletter-container').data('url'), function () {
        setTimeout(function () {
            observeNewsletter();
        }, 200);
    });
};

if ($('#newsletter-container').length) {
    loadNewsletter();
}

//product data collapsible    
$('.column_data .collapsible .collapse-button').click(function () {
    var element = $(this);
    var parent = element.closest('.collapsible');
    var target = element.data('target');

    parent.toggleClass('open');

    if (target) {
        $(target + ' .collapsible').each(function () {
            var child = $(this);

            if (parent.hasClass('open')) {
                child.addClass('open');
            } else {
                child.removeClass('open');
            }
        });
    }
});

//faq    
$('.faq article h1').on('click', function () {
    var article = $(this).closest('article');
    article.toggleClass('open');
});

//dwg
$('#DWGcategories #categories a[data-url]').click(function () {
    $('#DWGcategoriesLoading').show();
    $('#DWGproducts').load($(this).data('url'), function () {
        $('#DWGcategoriesLoading').hide();
        $('.dwg_container')
            .removeClass('dwg_select_files')
            .removeClass('dwg_select_categories')
            .addClass('dwg_select_products');
        $('#DWGfiles').html('');
    });

    return false;
});

//product
$(':radio[data-material-code]').change(function () {

    if ($(this).is(':checked')) {
        $('[data-material-code=' + $(this).data('materialCode') + ']').trigger('render.change');
        window.location.hash = '#' + $(this).data('materialHash');

        $('#CatNumberMaterial').text($(this).data('materialCode').toUpperCase());
    }
});

$('figure[data-material-code]').on('render.change', function (e) {
    $(this).closest('#RendersCont').find('figure[data-material-code]').removeClass('shown').hide();
    $(this).addClass('shown').show();
});

var hash = window.location.hash.substr(1);
if (hash) {
    $(':radio[data-material-hash=' + hash + ']').click();
}

//variants
$('#ProductsSwitch a').click(function () {
    $('.variant_select a.here').removeClass('here');
    $('.variant-container.active').removeClass('active');
    $(this).addClass('here');
    $($(this).attr('href')).addClass('active');
});

//contact
var getLocale = function () {
    var nav = window.navigator,
        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
        i,
        language;

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
        for (i = 0; i < nav.languages.length; i++) {
            language = nav.languages[i];
            if (language && language.length) {
                return language.toLowerCase();
            }
        }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
        language = nav[browserLanguagePropertyKeys[i]];
        if (language && language.length) {
            return language.toLowerCase();
        }
    }

    return null;
};

$('.contact_email, .contact_phone').each(function () {
    var element = $(this),
        value = element.attr('data-locale-' + getLocale());

    if (!value) {
        return;
    }
    var old = element.text().replace(/\s+/g, '');
    var trim = value.replace(/\s+/g, '');

    element.attr('href', element.attr('href').replace(old, trim));
    element.text(value);
});

//product list
$('#FilterButtons[data-url]').on('filters.reload', function () {
    var hash = window.location.hash.substr(1),
        url = $(this).data('url').replace('OPTIONS', hash);

    $('.products-list-outer').addClass('loading').load(url, function () {
        $(this).removeClass('loading').height($('.products-list-outer .products-list-inner').height());
    });
});

$('#FilterButtons[data-url]').on('filters.update', function () {
    var aliases = [];
    $('[data-alias].here').each(function () {
        aliases.push($(this).data('alias'));
    });
    window.location.hash = '#' + aliases.join('_');
    $(this).trigger('filters.reload');

    $('#FilterButtons .section').each(function () {
        var has = $(this).find('[data-alias].here').length;

        $(this).find('.reset').toggle(!!has);
    });
});

$('#FilterButtons [data-alias]').each(function () {
    var $this = $(this);

    $this.attr('href', $this.attr('href').replace('_', '#'));

    $this.click(function () {
        $this.toggleClass('here');
        $this.trigger('filters.update');

        return false;
    });
});

$('#FilterButtons .section .reset').hide().click(function () {
    $(this).closest('.section').find('[data-alias]').removeClass('here').trigger('filters.update');

    return false;
});

var hash = window.location.hash.substr(1);
if (hash) {
    $.each(hash.split('_'), function () {
        $('#FilterButtons [data-alias=' + this + ']').addClass('here');
    });

    $('#FilterButtons[data-url]').trigger('filters.update');
}

//street furniture
$('.street-furniture .video video').on('play progress canplay playing', function () {
    $(this).addClass('loaded');
});

//zano plus
$('.zano-plus .collapsible .show').click(function () {
    $(this).closest('.collapsible').removeClass('closed');
});
$('.zano-plus .collapsible .hide').click(function () {
    $(this).closest('.collapsible').addClass('closed');
});

//location
if ($('#change-location').length) {
    import('cookie').then((module) => {
        const Cookies = module.default;

        var changeLocation = function (location) {
            var $option = $('option[value=' + location + ']');

            $('.product-contact .current-location').text($option.text());
            $('.product-contact .flag').attr('class', 'flag flag-' + $option.val());

            $('.product-contact .contact-email').attr('href', $option.data('emailHref'));
            $('.product-contact .contact-email').text($option.data('emailTitle'));

            $('.product-contact .contact-phone').attr('href', $option.data('phoneHref'));
            $('.product-contact .contact-phone').text($option.data('phoneTitle'));
        };

        $('#change-location').change(function () {
            changeLocation($(this).val());
            Cookies.set('contactLocation', $(this).val(), { expires: 7 });
        });

        var location = Cookies.get('contactLocation');
        if (location) {
            changeLocation(location);
        } else {
            fetch('https://api.country.is')
                .then((r) => r.json())
                .then((json) => json.country?.toLowerCase())
                .then((code) => {
                    let options = $('#change-location option').map(function () {
                        return this.value;
                    });
                    if (!options.get().includes(code)) {
                        code = 'global';
                    }
                    changeLocation(code);
                    Cookies.set('contactLocation', code, { expires: 7 });
                });
        }
    });
}
